import { getAnalytics } from './global.analytics'
import { getNativeApp } from './global.nativeApp'

export const reconcileAnonymousId = (): void => {
  const analytics = getAnalytics()
  const mobileAnonymousId = getNativeApp()?.getAnonymousUserId() ?? null
  if (analytics) {
    if (mobileAnonymousId) {
      if (analytics.user().anonymousId() !== mobileAnonymousId) {
        analytics.setAnonymousId(mobileAnonymousId)
      }
    }
  }
}
